import { render, staticRenderFns } from "./monkeyDetail.vue?vue&type=template&id=242a7531&scoped=true&"
import script from "./monkeyDetail.vue?vue&type=script&lang=js&"
export * from "./monkeyDetail.vue?vue&type=script&lang=js&"
import style0 from "./monkeyDetail.vue?vue&type=style&index=0&id=242a7531&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242a7531",
  null
  
)

export default component.exports